import React from 'react'
import TermsAndConditions from '../components/AthleteSafetyRVP/TermsAndConditions/TermsAndConditions'
import ResourceLinkNav from '../components/shared/ResourceLinkNav/ResourceLinkNav'
import AdminView from '../components/shared/AdminView';

function TermsAndConditionsPage() {
  return (
    <ResourceLinkNav>
      <AdminView />
      <TermsAndConditions />
    </ResourceLinkNav>
  );
}

export default TermsAndConditionsPage;